import React from 'react';
import KeyValue from '../common/KeyValue'
import CollapsibleCard from '../common/CollapsibleCard'
import { getEmailDetails } from "../../../helpers/mailbox"

export default function EmailDetailsCard() {
    const {origDate, from, sender} = getEmailDetails();
    const origDateDisplay = origDate.toLocaleString([], {
        year: 'numeric', 
        month: 'numeric', 
        day: 'numeric', 
        hour: '2-digit', 
        minute: '2-digit'}
    );
    return (
        <CollapsibleCard header="Email Details" ctrlName="emailDetails" isOpen={true}>
              <KeyValue label="Origination Date:" value={origDateDisplay}/>
              <KeyValue label="From:" value={<>{from.displayName}<br/>{from.emailAddress}</>} />
              <KeyValue label="Sender:" value={<>{sender.displayName}<br/>{sender.emailAddress}</>}/>
        </CollapsibleCard>
    );
  }
  